<template>
    <div>
        <el-card>
            <template v-for="(item, index) in list">
                <div style="margin-bottom:10px;">
                    <span>{{ item.name }}</span>
                    <el-radio-group v-model="item.environment">
                        <el-radio :label="1">内测</el-radio>
                        <el-radio :label="2">外测</el-radio>
                        <el-radio :label="3">正式</el-radio>
                    </el-radio-group>
                    <el-button type="primary" @click="switchType(item, index)" size="mini">切换环境</el-button>
                </div>
            </template>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
            }
        },
        mounted() {
            this.getLists();
        },
        methods: {
            getLists() {
                HttpRequest.get('/admin.php?method=miniprogram.getEnvironmentList').then(response => {
					this.list = response.data.list;
				})
            },
            switchType(item, index) {
                let param = {
                    wxAppType: item.wxAppType,
                    environment: item.environment
                }
                HttpRequest.get('/admin.php?method=miniprogram.setEnvironment', param).then(response => {
                    if (response.data.success) {
                        this.$message('设置成功');
                    } else {
                        this.$message(response.msg);
                    }
				})
                .catch(() => {
                    this.$message.error('设置失败,请重新设置');
                })
            }
        }
    }
</script>

<style scoped>

</style>
